import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/error-tips.png'
import _imports_1 from '@/assets/images/successIcom.png'
import _imports_2 from '@assets/images/backIcon.png'


const _hoisted_1 = { class: "prompt-page-container" }
const _hoisted_2 = {
  key: 0,
  class: "prompt-inner-container error-container"
}
const _hoisted_3 = { class: "prompt-title" }
const _hoisted_4 = { class: "prompt-body" }
const _hoisted_5 = { class: "prompt-footer flex-row pass-test" }
const _hoisted_6 = { class: "grad-countdown" }
const _hoisted_7 = {
  key: 1,
  class: "prompt-inner-container"
}
const _hoisted_8 = { class: "prompt-title" }
const _hoisted_9 = { class: "prompt-body" }
const _hoisted_10 = {
  class: "prompt-footer flex-row pass-test",
  style: {"justify-content":"flex-end"}
}
const _hoisted_11 = { class: "btn-box" }

import { onMounted, onBeforeUnmount, reactive } from 'vue'
import { NCountdown} from 'naive-ui'
import type { CountdownProps } from 'naive-ui'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {
        type: String,
        default: '提示'
    },
    content: {
        type: String,
        default: ''
    },
    subContent: {
        type: String,
        default: ''
    },
    type: {
        type: Number,
        default: 0, // 0: 提示 0:失败提示  1: 成功
    },
},
  emits: ["onBack", "onRestart"],
  setup(__props, { emit: __emit }) {

/**
 * 提示页面: 新手教学，通关测试等页面中提示页面
 */
const props = __props

const emit = __emit

const renderErrorTip: CountdownProps['render'] = ({seconds}) => {
    if(seconds == 0){
        return `00`
    }else{
        return `${String(seconds).padStart(2, '0')}`
    }
}

const state = reactive({
    errorTipTotalTime:3000,
    startErrorTip:false,
})

onMounted(() => { 
    if(props.type == 0){ 
        state.startErrorTip = true
    }
})

onBeforeUnmount(() => { 
    if(props.type == 0){ 
        state.startErrorTip = false
    }
})



return (_ctx: any,_cache: any) => {
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.type == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(props.title), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(props.content), 1),
            _createElementVNode("span", null, _toDisplayString(props.subContent), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(NCountdown), {
                ref: "errorCountdownRef",
                duration: state.errorTipTotalTime,
                render: renderErrorTip,
                active: state.startErrorTip,
                "on-finish": ()=>emit('onRestart')
              }, null, 8, ["duration", "active", "on-finish"]),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text" }, "秒后自动开始", -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (props.type == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(props.title), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(props.content), 1),
            _createElementVNode("span", null, _toDisplayString(props.subContent), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_vkn_button, {
                label: "重新开始",
                type: "tertiary",
                size: "medium",
                onClick: _cache[0] || (_cache[0] = ()=>emit('onRestart'))
              }, {
                icon: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_vkn_button, {
                label: "返回",
                type: "tertiary",
                size: "medium",
                onClick: _cache[1] || (_cache[1] = ()=>emit('onBack'))
              }, {
                icon: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("img", { src: _imports_2 }, null, -1)
                ])),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})